import * as i0 from '@angular/core';
import * as i1 from './dialog.module';
import * as i2 from '@angular/common';
import * as i3 from '../common/auto-focus.directive';
import * as i4 from '../common/template-loader.component';
import * as i5 from '../common/resizeable.directive';
import * as i6 from '../common/dropdown.directive';
import * as i7 from '@angular/forms';
import * as i8 from './alert-dialog.component';
import * as i9 from './confirm-dialog.component';
import * as i10 from './prompt-dialog.component';
import * as i11 from '../common/trust-html.pipe';
import * as i12 from '../common/date.pipe';
import * as i13 from '../common/common.module';
export const DialogModuleNgFactory:i0.NgModuleFactory<i1.DialogModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.AutoFocusDirective = (<any>(null as any));
var _decl0_12:i4.TemplateLoaderComponent = (<any>(null as any));
var _decl0_13:i5.ResizeableDirective = (<any>(null as any));
var _decl0_14:i6.DropdownDirective = (<any>(null as any));
var _decl0_15:i7.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_16:i7.NgSelectOption = (<any>(null as any));
var _decl0_17:i7.ɵangular_packages_forms_forms_r = (<any>(null as any));
var _decl0_18:i7.DefaultValueAccessor = (<any>(null as any));
var _decl0_19:i7.ɵangular_packages_forms_forms_bd = (<any>(null as any));
var _decl0_20:i7.ɵangular_packages_forms_forms_bf = (<any>(null as any));
var _decl0_21:i7.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_22:i7.SelectControlValueAccessor = (<any>(null as any));
var _decl0_23:i7.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_24:i7.RadioControlValueAccessor = (<any>(null as any));
var _decl0_25:i7.NgControlStatus = (<any>(null as any));
var _decl0_26:i7.NgControlStatusGroup = (<any>(null as any));
var _decl0_27:i7.RequiredValidator = (<any>(null as any));
var _decl0_28:i7.MinLengthValidator = (<any>(null as any));
var _decl0_29:i7.MaxLengthValidator = (<any>(null as any));
var _decl0_30:i7.PatternValidator = (<any>(null as any));
var _decl0_31:i7.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_32:i7.EmailValidator = (<any>(null as any));
var _decl0_33:i7.FormControlDirective = (<any>(null as any));
var _decl0_34:i7.FormGroupDirective = (<any>(null as any));
var _decl0_35:i7.FormControlName = (<any>(null as any));
var _decl0_36:i7.FormGroupName = (<any>(null as any));
var _decl0_37:i7.FormArrayName = (<any>(null as any));
var _decl0_38:i8.AlertDialogComponent = (<any>(null as any));
var _decl0_39:i9.ConfirmDialogComponent = (<any>(null as any));
var _decl0_40:i10.PromptDialogComponent = (<any>(null as any));
var _decl0_41:i2.AsyncPipe = (<any>(null as any));
var _decl0_42:i2.UpperCasePipe = (<any>(null as any));
var _decl0_43:i2.LowerCasePipe = (<any>(null as any));
var _decl0_44:i2.JsonPipe = (<any>(null as any));
var _decl0_45:i2.SlicePipe = (<any>(null as any));
var _decl0_46:i2.DecimalPipe = (<any>(null as any));
var _decl0_47:i2.PercentPipe = (<any>(null as any));
var _decl0_48:i2.TitleCasePipe = (<any>(null as any));
var _decl0_49:i2.CurrencyPipe = (<any>(null as any));
var _decl0_50:i2.DatePipe = (<any>(null as any));
var _decl0_51:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_52:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_53:i2.KeyValuePipe = (<any>(null as any));
var _decl0_54:i11.TrustHtmlPipe = (<any>(null as any));
var _decl0_55:i12.DatePipe = (<any>(null as any));
var _decl0_56:i2.CommonModule = (<any>(null as any));
var _decl0_57:i13.RebirthCommonModule = (<any>(null as any));
var _decl0_58:i7.ReactiveFormsModule = (<any>(null as any));
var _decl0_59:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_60:i0.ElementRef<any> = (<any>(null as any));
function _View_AlertDialogComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_AlertDialogComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_38.context.title;
  currVal_0;
  const currVal_1:any = !_decl0_38.context.html;
  currVal_1;
  const currVal_2:any = _decl0_38.context.html;
  currVal_2;
  const currVal_3:any = i0.ɵinlineInterpolate(1,'btn btn-',_decl0_38.btnYesType,'');
  currVal_3;
  const currVal_4:any = (_decl0_38.context.yes || _decl0_38.btnYes);
  currVal_4;
  const pd_5:any = ((<any>_decl0_38.no()) !== false);
  const pd_6:any = ((<any>_decl0_38.yes()) !== false);
}
function _View_ConfirmDialogComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_ConfirmDialogComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.context.title;
  currVal_0;
  const currVal_1:any = !_decl0_39.context.html;
  currVal_1;
  const currVal_2:any = _decl0_39.context.html;
  currVal_2;
  const currVal_3:any = i0.ɵinlineInterpolate(1,'btn btn-',_decl0_39.btnYesType,'');
  currVal_3;
  const currVal_4:any = (_decl0_39.context.yes || _decl0_39.btnYes);
  currVal_4;
  const currVal_5:any = i0.ɵinlineInterpolate(1,'btn btn-',_decl0_39.btnNoType,'');
  currVal_5;
  const currVal_6:any = (_decl0_39.context.no || _decl0_39.btnNo);
  currVal_6;
  const pd_7:any = ((<any>_decl0_39.no()) !== false);
  const pd_8:any = ((<any>_decl0_39.yes()) !== false);
  const pd_9:any = ((<any>_decl0_39.no()) !== false);
}
function _View_PromptDialogComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_PromptDialogComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_40.context.title;
  currVal_0;
  const currVal_1:any = _decl0_40.form;
  currVal_1;
  const currVal_2:any = (_decl0_40.form.controls.promptValue.touched && _decl0_40.form.controls.promptValue.invalid);
  currVal_2;
  const currVal_3:any = ((_decl0_40.content == null)? (null as any): _decl0_40.content.label);
  currVal_3;
  const currVal_4:any = (<any>{$implicit:_decl0_40,option:_decl0_40.context,formGroup:_decl0_40.form});
  currVal_4;
  const currVal_5:any = (_decl0_40.content.template || _any);
  currVal_5;
  const currVal_6:any = _decl0_40.form.controls.promptValue.touched;
  currVal_6;
  const currVal_7:any = (_decl0_40.form.untouched || _decl0_40.form.invalid);
  currVal_7;
  const currVal_8:any = i0.ɵinlineInterpolate(1,'btn btn-',_decl0_40.btnYesType,'');
  currVal_8;
  const currVal_9:any = (_decl0_40.context.yes || _decl0_40.btnYes);
  currVal_9;
  const currVal_10:any = i0.ɵinlineInterpolate(1,'btn btn-',_decl0_40.btnNoType,'');
  currVal_10;
  const currVal_11:any = (_decl0_40.context.no || _decl0_40.btnNo);
  currVal_11;
  const pd_12:any = ((<any>_decl0_40.no()) !== false);
  const pd_13:any = ((<any>_decl0_40.yes()) !== false);
  const pd_14:any = ((<any>_decl0_40.no()) !== false);
}
